import { action, makeAutoObservable, observable } from "mobx";
import Agent from "env/agent";

import { StoreBaseMethods } from "./storeBase";

class UserStore  {
  host = null
  constructor({ data, host, authTokens } = {}) {
    makeAutoObservable(this, undefined, {autoBind: true});
    StoreBaseMethods.copyData(data, this);
    this.authTokens = authTokens;
    this.host = host || data?.host;
  }

  get agent() {
    return new Agent(this.host, this.authTokens);
  }
  @observable userAlreadyExistsOkta = false;
  @action existsOkta(email) {
    if (!email) this.userAlreadyExistsOkta = false;
    return this.agent
      .User.exists(email)
      .then(
        action((data) => {
          this.userAlreadyExistsOkta = data;
          return data;
        })
      );
  }
}

export default UserStore;
